import { TranslatorConverter } from "src/TranslatorConverter";
import { Enum, IEnumTranslator } from "uicomponents";

export class processStateEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2,3,4];        
    }
    GetString(value: any) {
        return new TranslatorConverter().paymentProcessStateNameConverter(value);
    }
}

export class processTypeEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2,3];        
    }
    GetString(value: any) {
        return new TranslatorConverter().paymentProcessTypeNameConverter(value);
    }
}

export class TransactionTransferTypeEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2,3,4,5,6,7,8];        
    }
    GetString(value: any) {
        return new TranslatorConverter().transactionTransferTypeNameConverter(value);
    }
}
